<template>
  <div style="width: 100%; height: 160px; position: relative" :style="{ backgroundColor: cardColor }">
    <!--Buttons bar-->
    <v-menu left>
      <template v-slot:activator="{ on }">
        <v-btn icon
               color="white"
               style="position: absolute; right: 0; top: 5px"
               v-on="on">
          <v-icon size="25px">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list color="kbLight">
        <v-list-item @click="changeUserFromSequence()">
          <v-list-item-action>
            <v-icon color="kbDarkBlueText">mdi-file-tree</v-icon>
          </v-list-item-action>
          <v-list-item-title
            class="kbDarkBlueText--text"
          >{{ $t('general.changeUserFromSequence') }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="deleteUserFromSequence()">
          <v-list-item-action>
            <v-icon color="kbDarkBlueText">mdi-delete</v-icon>
          </v-list-item-action>
          <v-list-item-title
            class="kbDarkBlueText--text"
          >{{ $t('general.deleteUserFromSequence') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-row no-gutters class="px-4" align="center" justify="center" style="height: 100%">
      <v-col class="d-flex" cols="5">
        <!--User Image, name and location-->
        <div class="d-flex flex-column align-center" style="width: 100%">
          <div class="user-image-container elevation-3">
            <img :src="image"
                 alt="Profile Image"
                 v-show="image && wasImageLoadedCorrectly"
                 @click="viewUser()"
                 @load="checkProfileImageLoad(true)"
                 @error="checkProfileImageLoad(false)">
            <v-icon color="kbGrayLightText"
                    size="67px"
                    v-show="!image || !wasImageLoadedCorrectly"
                    @click="viewUser()">
              mdi-account-circle
            </v-icon>
          </div>
          <span class="white--text text-capitalize text-center pt-1"
                style="font-size: 15px">
            {{ person.name }}
          </span>
          <span class="white--text text-capitalize font-weight-light"
                style="font-size: 12px"
                v-if="location.city && location.region">
            {{ location.city }}, {{ location.region }}
          </span>
          <span class="white--text text-capitalize"
                style="font-size: 12px"
                v-if="person.currentStepStatus">
            {{ $t('general.status') }}: {{ person.currentStepStatus }}
          </span>
        </div>
      </v-col>
      <v-col class="pb-3" cols="7" style="align-self: flex-end">
        <div class="d-flex flex-column align-center">
          <p class="white--text font-weight-light text-center mb-2" style="font-size: 13px">
            {{ description }},
            <span class="white--text" style="font-size: 13px">
              Contact me at
            </span>
          </p>

          <v-btn @click="executeAction" icon outlined color="white">
            <v-icon>{{ stepOptions.icon }}</v-icon>
          </v-btn>
          <!--<div class="text-center mb-2" style="cursor: pointer">
            <span class="text-center white pa-1" style="font-size: 12px" :style="{ color: cardColor }">
              Email Validation Score 90
            </span>
          </div>
          <div class="d-flex flex-wrap justify-center align-center">
            <v-btn class="d-flex align-center mr-1 py-2" color="white" outlined small>
              <v-icon class="mr-1">mdi-email-outline</v-icon>
              <span class="white&#45;&#45;text text-uppercase">A</span>
            </v-btn>
            <v-btn class="d-flex align-center py-2" color="white" outlined small>
              <v-icon class="mr-1">mdi-email-outline</v-icon>
              <span class="white&#45;&#45;text text-uppercase">B</span>
            </v-btn>
          </div>-->
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  computed: {
    stepOptions () {
      switch (this.stepType) {
        case 'email':
          return { icon: 'mdi-email' }
        case 'task':
          return { icon: 'mdi-calendar' }
        case 'sms':
          return { icon: 'mdi-message-processing' }
        case 'call':
          return { icon: 'mdi-phone' }
        default:
          return { icon: 'mdi-email' }
      }
    }
  },
  data () {
    return {
      wasImageLoadedCorrectly: false
    }
  },
  methods: {
    changeUserFromSequence () {
      this.$emit('changeUserFromSequence', this.person.userId)
    },
    checkProfileImageLoad (value) {
      this.wasImageLoadedCorrectly = value
    },
    deleteUserFromSequence () {
      this.$emit('deleteUserFromSequence', this.person.userId)
    },
    executeAction () {
      if (this.stepType === 'mEmail') {
        this.$emit('openEmailComposer', this.person.email)
      }
    },
    viewUser () {
      this.$emit('viewUser')
    }
  },
  props: {
    cardColor: {
      type: String,
      default: '#4279D6'
    },
    description: {
      type: String,
      default: 'This is a brief description of me'
    },
    image: {
      type: String,
      default: ''
    },
    location: {
      type: Object,
      default: () => ({ city: 'Medellín', region: 'Colombia' })
    },
    person: {
      type: Object,
      default: () => {}
    },
    stepType: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>
  .user-image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid white;
    border-radius: 50%;
    background-color: white;
    height: 60px;
    width: 60px;
  }
  .user-image-container img {
    border-radius: 50%;
    width: 100%;
    height: 100%;
  }
</style>
